import React from 'react';

/**
 * Reusable Digital Pipeline Table Component
 */
const DigitalPipelineTable = ({ plName, data }) => {

    /* ✅ Hide Others table visually but keep for PPT export */
    if (
        plName === "Others Digital Pipeline" ||
        plName?.toLowerCase() === "others"
    ) {
        return (
            <div style={{ display: "none" }}>
                <table id={`digitalPipeline_${plName}`}></table>
            </div>
        );
    }

    const headers = [
        'C0',
        'C1',
        'C1A',
        'C2',
        'C3',
        'Overall C3',
        '%C3 from Digital',
        'C0-C3%'
    ];

    /* Clean data */
    const cleanData =
        data?.filter(
            (row) =>
                !row.isTotal &&
                row.state &&
                row.state.toLowerCase() !== "others digital pipeline"
        ) || [];

    /* Grand Total */
    const grandTotals = headers.map((_, colIndex) => {

        // %C3 from Digital
        if (colIndex === 6) {

            const totalDigitalC3 = cleanData.reduce(
                (sum, row) => sum + (parseFloat(row.vals[4]) || 0),
                0
            );

            const totalOverallC3 = cleanData.reduce(
                (sum, row) => sum + (parseFloat(row.vals[5]) || 0),
                0
            );

            if (!totalOverallC3) return "-";

            return ((totalDigitalC3 / totalOverallC3) * 100).toFixed(1) + "%";
        }

        // C0-C3 %
        if (colIndex === 7) {

            const totalC0 = cleanData.reduce(
                (sum, row) => sum + (parseFloat(row.vals[0]) || 0),
                0
            );

            const totalC3 = cleanData.reduce(
                (sum, row) => sum + (parseFloat(row.vals[4]) || 0),
                0
            );

            if (!totalC0) return "-";

            return ((totalC3 / totalC0) * 100).toFixed(1) + "%";
        }

        // Normal columns
        return cleanData.reduce(
            (sum, row) =>
                sum + (parseFloat(row.vals[colIndex]) || 0),
            0
        );

    });

    const grandTotalRow = {
        state: "Grand Total",
        isTotal: true,
        vals: grandTotals
    };

    const tableData = [...cleanData, grandTotalRow];

    return (

        <div className="flex flex-col mb-6 m-1 w-[400px] h-[250px] md:w-full">

            <h3 className="text-[#234b63] font-bold text-[14px] mb-2 px-1 uppercase tracking-tight">
                {plName} Digital Pipeline
            </h3>

            <div className="overflow-auto border border-slate-200 rounded-lg shadow-sm max-h-[400px]">

                <table
                    id={`digitalPipeline_${plName}`}
                    className="w-full min-w-max border-collapse relative"
                >

                    <thead>

                        <tr>

                            <th className="bg-[#234b63] text-white font-semibold px-4 py-2 border border-[#315d7a] text-left text-xs sticky top-0 z-30">
                                State Office
                            </th>

                            {headers.map((h, i) => (

                                <th
                                    key={i}
                                    className="bg-[#234b63] text-white font-semibold px-2 py-2 border border-[#315d7a] text-center text-xs sticky top-0 z-30"
                                >
                                    {h}
                                </th>

                            ))}

                        </tr>

                    </thead>

                    <tbody>

                        {tableData.map((row, i) => (

                            <tr
                                key={i}
                                className={
                                    row.isTotal
                                        ? "sticky bottom-0 z-20"
                                        : "hover:bg-slate-50 transition-colors"
                                }
                            >

                                <td
                                    className={`px-4 py-2 border border-slate-200 text-left text-xs font-semibold whitespace-nowrap ${row.isTotal
                                        ? 'bg-[#d8eaf5] text-[#1e3a4c] border-t-2 border-t-[#1e3a4c]/20'
                                        : 'bg-slate-50 text-slate-800'
                                        }`}
                                >
                                    {row.state}
                                </td>

                                {row.vals.slice(0, 8).map((val, j) => (

                                    <td
                                        key={j}
                                        className={`px-2 py-2 border border-slate-200 text-center text-xs whitespace-nowrap ${row.isTotal
                                            ? 'font-bold bg-[#e3eff7] text-[#1e3a4c] border-t-2 border-t-[#1e3a4c]/20'
                                            : 'text-slate-600'
                                            }`}
                                    >
                                        {val}
                                    </td>

                                ))}

                            </tr>

                        ))}

                    </tbody>

                </table>

            </div>

        </div>

    );

};

export default DigitalPipelineTable;